/* tslint:disable */
/* eslint-disable */
/* @relayHash ddbaf87a741c5f0995163530b1c1f785 */

import { ConcreteRequest } from "relay-runtime";
export type HomepageHoldoutGroup = "consumer" | "control" | "trade" | "%future added value";
export type checkHoldoutGroupQueryVariables = {
    userId: string;
};
export type checkHoldoutGroupQueryResponse = {
    readonly viewer: {
        readonly homepageUserGroup: HomepageHoldoutGroup | null;
    };
};
export type checkHoldoutGroupQuery = {
    readonly response: checkHoldoutGroupQueryResponse;
    readonly variables: checkHoldoutGroupQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "userId",
      "variableName": "userId"
    }
  ],
  "kind": "ScalarField",
  "name": "homepageUserGroup",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "checkHoldoutGroupQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "checkHoldoutGroupQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/306.0.0-2021-03-11T04:05:43.156Z/checkHoldoutGroupQuery",
    "metadata": {},
    "name": "checkHoldoutGroupQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = '57d231fc084783b14d344ca83fa0023f';
export default node;
